import { FiInfo } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertTitle } from '@britishcouncil/react-registration-platform';

const RUSSIA_ISO_CODE = 'RU';
const IRAN_ISO_CODE = 'IR';

type CountryRiskNoticeProps = {
  isoCode?: string | null;
};

export const CountryRiskNotice = ({ isoCode }: CountryRiskNoticeProps) => {
  const { t } = useTranslation('');

  if (isoCode === RUSSIA_ISO_CODE) {
    return (
      <Alert variant="warning" data-testid="country-risk-notice-russia">
        <FiInfo size={20} />
        <AlertTitle>{t('personal-details.contact-details.country-notice')}</AlertTitle>
        <AlertDescription>{t('personal-details.contact-details.russia-risk')}</AlertDescription>
      </Alert>
    );
  }

  if (isoCode === IRAN_ISO_CODE) {
    return (
      <Alert variant="warning" data-testid="country-risk-notice-iran">
        <FiInfo size={20} />
        <AlertTitle>{t('personal-details.contact-details.iran-notice')}</AlertTitle>
        <AlertDescription>
          <div className="flex flex-col gap-y-3">
            <p>{t('personal-details.contact-details.iran-risk.intro')}</p>
            <p>{t('personal-details.contact-details.iran-risk.ban')}</p>
            <p>{t('personal-details.contact-details.iran-risk.sanctions')}</p>
            <ul className="list-disc pl-5 flex flex-col gap-y-3">
              <li>{t('personal-details.contact-details.iran-risk.residence')}</li>
              <li>{t('personal-details.contact-details.iran-risk.proof-of-residence')}</li>
            </ul>
            <p>{t('personal-details.contact-details.iran-risk.consider')}</p>
          </div>
        </AlertDescription>
      </Alert>
    );
  }

  return null;
};
